<p-dialog [visible]="showLostReason()" [resizable]="false" appendTo="body" [modal]="true"
  [breakpoints]="{'1199px': '100vw'}" [style]="{width: '57vw'}" styleClass="no-header-modal">

  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">


    <!-- Header -->
    <div class="flex align-items-center justify-content-between border-bottom-1 border-300">
      <div class="flex align-items-center">
        <div class="h-3rem w-6rem flex align-items-center text-primary border-right-2 border-300 mr-3 cursor-pointer p-3"
          (click)="closeReasonDailog()">
          <i class="fa fa-chevron-left mr-2 rotate-180-rtl"></i>
          <span class="text-sm">BACK</span>
        </div>
        @if (reason() && reason().name) {
          <h2 class="mb-0 text-sm capitalize">{{reason().name}}</h2>
        }
      </div>
      <div class="fa fa-times text-xl text-600 cursor-pointer mx-3" (click)="closeReasonDailog()"></div>
    </div>
    <!-- Header -->

    <!-- Header -->
    <!-- <div class="flex align-items-center justify-content-between py-2 px-4 border-bottom-2 border-300">
    <div class="flex align-items-center my-1">
      <span class="mr-2"><img class="border-circle" width="32" *ngIf="dealInfo && dealInfo.client_info.image" [src]="dealInfo.client_info.image"  alt="Avatar" /></span>
      <span class="text-primary font-bold text-lg mr-2" *ngIf="dealInfo">{{dealInfo.client_info.full_name}}</span>
      <span class="text-600 font-normal text-sm" *ngIf="dealInfo">Client ID - {{dealInfo.client_info.id}}</span>
    </div>
    <div [innerHTML]="clientStatus(dealInfo.client_info)"></div>
  </div> -->
  <!-- Header -->


  <div class="surface-0 border-round shadow-3 m-3">

    <div class="flex align-items-center justify-content-between p-3">
      <div class="flex align-items-center">
        @if (dealInfo().client_info && dealInfo().client_info.image) {
          <span class="mr-2"><img class="border-circle" width="32" [src]="dealInfo().client_info.image" alt="Avatar" /></span>
        }
        @if (dealInfo() && dealInfo().client_info) {
          <span class="text-primary font-bold text-base mr-2">{{dealInfo().client_info.full_name}}</span>
        }
        @if (dealInfo() && dealInfo().client_info) {
          <span class="text-600 font-normal text-sm"> - {{dealInfo().client_info.id}}</span>
        }
      </div>
      <div class="flex align-items-center">
        @if (dealInfo() && dealInfo().client_info) {
          <div [innerHTML]="clientStatus(dealInfo().client_info)"></div>
        }
      </div>
    </div>

  </div>


  <!-- Content -->
  <div class="flex">

    <!-- Left Side-->
    <div class="border-right-2 border-300 lg:w-8 w-full">
      @if (reason() && reason().title && reason().title === 'lost-to-competitor-img') {
        <form [formGroup]="lostToCompetitors" (ngSubmit)="saveLostAsDeal('LostToCompetitor')">
          <div class="p-4 surface-100">
            <div class="mb-3">
              <h4 class="font-medium text-700 text-xs mb-2 block uppercase">{{'OPPORTUNITY.LOSTDEAL.NAMEOFCOMPETITOR' | translate}}</h4>
              <ff-google-places [competitorName]="CompetitorName" [placeHolderName]="'OPPORTUNITY.LOSTDEAL.NAMEOFCOMPETITOR' | translate" (fetchPlaceInfo)="getPlaceDetails($event)" />
              @if (CompetitorName.touched && CompetitorName.invalid) {
                <app-error-msg [errors]="CompetitorName.errors"
                [fieldLabel]="'OPPORTUNITY.LOSTDEAL.NAMEOFCOMPETITOR' | translate" />
              }
            </div>
            <div class="mb-3">
              <h4 class="font-medium text-700 text-xs mb-2 block uppercase">{{'OPPORTUNITY.LOSTDEAL.CONTRACTENDDATE' | translate}}</h4>
              <p class="mb-2 text-600 text-sm">{{'OPPORTUNITY.LOSTDEAL.CONTRACTENDDATEINSTRUCTOR' | translate}}</p>
              <p-datepicker [showIcon]="true"  formControlName="contractEndDate" placeholder="Select Date"
              inputStyleClass="text-sm w-full" styleClass="w-full" />
              @if (ContractEndDate.touched && ContractEndDate.invalid) {
                <app-error-msg [errors]="ContractEndDate.errors"
                [fieldLabel]="'OPPORTUNITY.LOSTDEAL.CONTRACTENDDATE' | translate" />
              }
            </div>
            <div class="mb-2 md:mb-3">
              <h4 class="font-medium text-700 text-xs mb-1 block uppercase">{{'OPPORTUNITY.LOSTDEAL.COMMENT' | translate}}</h4>
              <h5 class="text-sm mb-2 text-700">{{'OPPORTUNITY.LOSTDEAL.WHATCOULDHAVEDONEBETTER' | translate}}</h5>
              <p class="mb-2 text-600 text-sm">{{'OPPORTUNITY.LOSTDEAL.LOSTDUETOCOMPETITORINSTRUCTOR' | translate}}</p>
              <textarea pInputTextarea class="w-full h-7rem text-sm" formControlName="lostToCompetitorComments" placeholder="{{'OPPORTUNITY.LOSTDEAL.ADD_COMMENTS' | translate}}"></textarea>
              @if (LostToCompetitorComments.touched && LostToCompetitorComments.invalid) {
                <app-error-msg [errors]="LostToCompetitorComments.errors"
                [fieldLabel]="'OPPORTUNITY.LOSTDEAL.COMMENT' | translate" />
              }
            </div>
          </div>
          <!-- Modal Footer -->
          <div class="p-3 flex align-items-center justify-content-between border-top-1 border-400 surface-0">
            <div class="col-4">
              <p-button label="{{'ADMIN.COMMON.CANCEL' | translate}}" styleClass="p-button-link text-sm"  (click)="closeAllDialogs()" />
            </div>
            <div class="col-8 text-right">
              <button type="submit" class="text-sm" pButton pRipple label="{{'ADMIN.COMMON.SAVE' | translate}}" [disabled]="!lostToCompetitors.valid" ></button>
            </div>
          </div>
          <!-- Modal Footer -->
        </form>
      }
      @if (reason() && reason().title && reason().title === 'lost-to-high-price') {
        <form [formGroup]="lostDueToHighPrice" (ngSubmit)="saveLostAsDeal('HighPrice')">
          <div class="p-4 surface-100">
            <div class="mb-5">
              <h4 class="font-medium text-700 text-xs mb-2 block uppercase">{{'OPPORTUNITY.LOSTDEAL.EXPECTED_PRICE' | translate}}</h4>
              <p class="mb-2 text-600 text-sm">{{'OPPORTUNITY.LOSTDEAL.AUTO_FOLLOW_UP' | translate}}</p>
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon border-noround-right line-height-1">$</span>
                <!-- <p-inputNumber [format]="false" class="w-full text-sm" placeholder="{{'OPPORTUNITY.LOSTDEAL.AMOUNT' | translate}}"  formControlName="expectedPrice"></p-inputNumber> -->
                <app-input-number [formGroup]="lostDueToHighPrice" [controlName]="ExpectedPrice"
                  [styleClass]="'w-6rem text-sm border-left-none border-noround-left'" [conditionToFormat]="false" [placeholder]="'OPPORTUNITY.LOSTDEAL.AMOUNT' | translate"  />
              </div>
              @if (ExpectedPrice.touched && ExpectedPrice.invalid) {
                <app-error-msg [errors]="ExpectedPrice.errors"
                [fieldLabel]="'OPPORTUNITY.LOSTDEAL.EXPECTED_PRICE' | translate" />
              }
            </div>
            <div class="mb-2 md:mb-5">
              <h4 class="font-medium text-700 text-xs mb-1 block uppercase">{{'OPPORTUNITY.LOSTDEAL.COMMENTS' | translate}}</h4>
              <p class="mb-2 text-600 text-sm">{{'OPPORTUNITY.LOSTDEAL.AUTO_FOLLOW_UP' | translate}}</p>
              <textarea pInputTextarea class="w-full h-9rem text-sm" formControlName="lostHighPriceComments" placeholder="{{'OPPORTUNITY.LOSTDEAL.ADD_COMMENTS' | translate}}"></textarea>
              @if (LostHighPriceComments.touched && LostHighPriceComments.invalid) {
                <app-error-msg [errors]="LostHighPriceComments.errors"
                [fieldLabel]="'OPPORTUNITY.LOSTDEAL.COMMENTS'| translate" />
              }
            </div>
          </div>
          <!-- Modal Footer -->
          <div class="lg:px-4 px-2 pt-3 pb-1 border-top-1 border-400">
            <div class="grid align-items-center justify-content-between">
              <div class="col-4">
                <p-button label="{{'ADMIN.COMMON.CANCEL' | translate}}" styleClass="p-button-link text-sm"   (click)="closeAllDialogs()"
                 />
              </div>
              <div class="col-8 text-right">
                <button type="submit" class="text-sm" pButton pRipple label="{{'ADMIN.COMMON.SAVE' | translate}}" [disabled]="!lostDueToHighPrice.valid"
                ></button>
              </div>
            </div>
          </div>
          <!-- Modal Footer -->
        </form>
      }
      @if (reason() && reason().title && reason().title === 'lost-to-missing-facility-img') {
        <form [formGroup]="missingFacility" (ngSubmit)="saveLostAsDeal('MissingFacility')">
          <div class="p-4 surface-100">
            <div class="mb-5">
              <h4 class="font-medium text-700 text-xs mb-1 block uppercase">{{'OPPORTUNITY.LOSTDEAL.SELECT_FACILITIES' | translate}}</h4>
              <p class="mb-2 text-600 text-sm">{{'OPPORTUNITY.LOSTDEAL.AUTO_FOLLOW_UP' | translate}}</p>
              <p-autocomplete formControlName="selectFacilities" [multiple]="true" [typeahead]="false" [addOnBlur]="true" [forceSelection]="false" inputStyleClass="text-sm" styleClass="w-full text-sm p-0" placeholder="Type and select your options…" />
              @if (SelectFacilities.touched && SelectFacilities.invalid) {
                <app-error-msg [errors]="SelectFacilities.errors"
                [fieldLabel]="'OPPORTUNITY.LOSTDEAL.SELECT_FACILITIES' | translate" />
              }
            </div>
            <div class="mb-2 md:mb-5">
              <h4 class="font-medium text-700 text-xs mb-1 block uppercase">{{'OPPORTUNITY.LOSTDEAL.COMMENTS' | translate}}</h4>
              <p class="mb-2 text-600 text-sm">{{'OPPORTUNITY.LOSTDEAL.AUTO_FOLLOW_UP' | translate}}</p>
              <textarea pInputTextarea class="w-full h-9rem text-sm" formControlName="missingFacilityComments"  placeholder="Add Comments..."></textarea>
              @if (MissingFacilityComments.touched && MissingFacilityComments.invalid) {
                <app-error-msg [errors]="MissingFacilityComments.errors"
                [fieldLabel]="'OPPORTUNITY.LOSTDEAL.COMMENTS' | translate" />
              }
            </div>
          </div>
          <!-- Modal Footer -->
          <div class="lg:px-4 px-2 pt-3 pb-1 border-top-1 border-400">
            <div class="grid align-items-center justify-content-between">
              <div class="col-4">
                <p-button label="{{'ADMIN.COMMON.CANCEL' | translate}}" styleClass="p-button-link text-sm"  (click)="closeAllDialogs()" />
              </div>
              <div class="col-8 text-right">
                <button type="submit" class="text-sm" pButton pRipple label="{{'ADMIN.COMMON.SAVE' | translate}}" [disabled]="!missingFacility.valid"></button>
              </div>
            </div>
          </div>
          <!-- Modal Footer -->
        </form>
      }
      @if (reason() && reason().title && reason().title === 'lost-to-other-reasons-img') {
        <form [formGroup]="otherReasons" (ngSubmit)="saveLostAsDeal('OtherReasons')">
          <div class="p-4 surface-100">
            <div class="mb-5">
              <h4 class="font-medium text-700 text-xs mb-1 block uppercase">{{'OPPORTUNITY.LOSTDEAL.REASON' | translate}}</h4>
              <p class="mb-2 text-600 text-sm">{{'OPPORTUNITY.LOSTDEAL.SELECT_REASON' | translate}}</p>
              <p-select [options]="reasons" formControlName="reason"  optionLabel="name" filterBy="name" styleClass="w-full text-sm" placeholder="{{'OPPORTUNITY.LOSTDEAL.SELECT_REASON' | translate}}">
                <ng-template pTemplate="selectedItem">
                  @if (Reason) {
                    <div class="text-sm">
                      {{Reason.value.name | uppercase}}
                    </div>
                  }
                </ng-template>
                <ng-template let-reason pTemplate="item">
                  <div class="text-sm">{{reason.name | uppercase}}</div>
                </ng-template>
              </p-select>
              @if (Reason.touched && Reason.invalid) {
                <app-error-msg [errors]="Reason.errors"
                [fieldLabel]="'OPPORTUNITY.LOSTDEAL.REASON' | translate" />
              }
            </div>
            <div class="mb-2 md:mb-5">
              <h4 class="font-medium text-700 text-xs mb-1 block uppercase">{{'OPPORTUNITY.LOSTDEAL.COMMENTS' | translate}}</h4>
              <p class="mb-2 text-600 text-sm">{{'OPPORTUNITY.LOSTDEAL.AUTO_FOLLOW_UP' | translate}}</p>
              <textarea pInputTextarea  formControlName="otherReasonsComments"  class="w-full h-9rem text-sm" placeholder="{{'OPPORTUNITY.LOSTDEAL.ADD_COMMENTS' | translate}}"></textarea>
              @if (OtherReasonsComments.touched && OtherReasonsComments.invalid) {
                <app-error-msg [errors]="OtherReasonsComments.errors"
                [fieldLabel]="'OPPORTUNITY.LOSTDEAL.COMMENTS' | translate" />
              }
            </div>
          </div>
          <!-- Modal Footer -->
          <div class="lg:px-4 px-2 pt-3 pb-1 border-top-1 border-400">
            <div class="grid align-items-center justify-content-between">
              <div class="col-4">
                <p-button label="{{'ADMIN.COMMON.CANCEL' | translate}}" styleClass="p-button-link text-sm"  (click)="closeAllDialogs()" />
              </div>
              <div class="col-8 text-right">
                <button type="submit" class="text-sm" pButton pRipple label="{{'ADMIN.COMMON.SAVE' | translate}}" [disabled]="!otherReasons.valid"></button>
              </div>
            </div>
          </div>
          <!-- Modal Footer -->
        </form>
      }
      @if (reason() && reason().title && reason().title === 'lost-to-no-contactable-img') {
        <form [formGroup]="notContactable" (ngSubmit)="saveLostAsDeal('NotContactable')">
          <div class="p-4 surface-100">
            <div class="mb-2 md:mb-5">
              <h4 class="font-medium text-700 text-xs mb-1 block uppercase">{{'OPPORTUNITY.LOSTDEAL.COMMENTS' | translate}}</h4>
              <p class="mb-2 text-600 text-sm">{{'OPPORTUNITY.LOSTDEAL.AUTO_FOLLOW_UP' | translate}}</p>
              <textarea pInputTextarea formControlName="notContactableComments" class="w-full h-9rem text-sm" placeholder="{{'OPPORTUNITY.LOSTDEAL.ADD_COMMENTS' | translate}}"></textarea>
              @if (NotContactableComments.touched && NotContactableComments.invalid) {
                <app-error-msg [errors]="NotContactableComments.errors"
                [fieldLabel]="'Comments'" />
              }
            </div>
          </div>
          <!-- Modal Footer -->
          <div class="lg:px-4 px-2 pt-3 pb-1 border-top-1 border-400">
            <div class="grid align-items-center justify-content-between">
              <div class="col-4">
                <p-button label="{{'ADMIN.COMMON.CANCEL' | translate}}" styleClass="p-button-link text-sm" (click)="closeAllDialogs()"
                 />
              </div>
              <div class="col-8 text-right">
                <button type="submit" class="text-sm" pButton pRipple label="{{'ADMIN.COMMON.SAVE' | translate}}"  [disabled]="!notContactable.valid"
                ></button>
              </div>
            </div>
          </div>
          <!-- Modal Footer -->
        </form>
      }
    </div>
    <!-- Left Side -->

    <!-- Right Side -->
    <app-lost-deal-banner [title]="reason().title" class="p-2 align-items-center justify-content-center w-4 hidden lg:flex" />
    <!-- Right Side -->

  </div>
  <!-- Content -->

</ng-template>

</p-dialog>

